// SOTW Landing Page
import "@/modules/bottom-hero-nav.js";

console.log("SOTW LP loaded");
